import React from 'react'

const GPS = props => {

  const onClick = e => {
    console.log('You have clicked the GPS...well done.');
  };
  return (
    <div className="GPS" onClick={e=>onClick(e)} />
  )
};

export default GPS